/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConsoleNotificationDto { 
    id?: number;
    title?: string;
    message?: string;
    image?: string;
    loyaltyProgramId?: number;
    loyaltyProgramName?: string;
    target?: ConsoleNotificationDto.TargetEnum;
    status?: ConsoleNotificationDto.StatusEnum;
    scheduledAt?: string;
    sentAt?: string;
    recipientCount?: number;
    deliveredCount?: number;
    readCount?: number;
    openRatePct?: number;
}
export namespace ConsoleNotificationDto {
    export type TargetEnum = 'ALL' | 'ACTIVE_30D' | 'INACTIVE';
    export const TargetEnum = {
        All: 'ALL' as TargetEnum,
        Active30D: 'ACTIVE_30D' as TargetEnum,
        Inactive: 'INACTIVE' as TargetEnum
    };
    export type StatusEnum = 'SCHEDULED' | 'SENT';
    export const StatusEnum = {
        Scheduled: 'SCHEDULED' as StatusEnum,
        Sent: 'SENT' as StatusEnum
    };
}


